import React, { useEffect } from 'react';
import './../css/Topbar.css';
import Account from './AccountDropdown';
import { useAuth } from '../api/auth/store';
import useUXStore from '../api/ux/store';
import { Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { redirectToLogin } from '../utils/functions';
import NotificationBell from './NotificationBell';

const Topbar: React.FC = () => {
  const { sessionDetails, sessionExpired, setSessionExpired, signed } = useAuth(state => state)
  const { refreshDialog, hideDialog } = useUXStore(state => state)
  const navigate = useNavigate()

  useEffect(() => {
    if (!sessionExpired) {
      // the session is healthy again (e.g. it was replaced by a company switch).
      // drop any prompt a request racing that swap may have raised
      if (useUXStore.getState().dialogs.has("session-timeout"))
        hideDialog("session-timeout")
      return
    }
    if (signed && sessionExpired) {
      // Show session timeout modal using uxDialog
      refreshDialog({
        id: "session-timeout",
        title: "Session Expired",
        content: "Your session has expired. Please re-authenticate to continue.",
        visible: true,
        confirmContent: "Re-authenticate",
        confirmActive: true,
        onConfirm: () => {
          // Reset session expired state and redirect to auth page
          setSessionExpired(false)
          redirectToLogin();
          //navigate("/sso?client=" + CLIENT_ID)
        }
      }, true) // autohide = true
    }
  }, [sessionExpired, refreshDialog, hideDialog, setSessionExpired, navigate, signed])

  return (
    <nav className="topbar">
      <div className='container' style={{ maxWidth: "1200px" }}>
        <Stack direction="horizontal" gap={3} className="topbar-content">
          <div className="brand-name">CPASS</div>
          {/* Add other navigation items here if needed */}
          <Stack direction="horizontal" gap={2}>
            {signed && <NotificationBell />}
            {sessionDetails && <Account user={sessionDetails} />}
          </Stack>

        </Stack>
      </div>
    </nav>
  );
};

export default Topbar;
